export const UPDATE_PAGATORE_PREMIO                = 'UPDATE_PAGATORE_PREMIO';
export const UPDATE_MODALITA_PAGAMENTO             = 'UPDATE_MODALITA_PAGAMENTO';
export const SALVA_DATI_MODALITA_PAGAMENTO         = 'SALVA_DATI_MODALITA_PAGAMENTO';
export const UPDATE_DATI_MODALITA_PAGAMENTO_VALIDA = 'UPDATE_DATI_MODALITA_PAGAMENTO_VALIDA';
export const UPDATE_NEED_ESECUTORE                 = 'UPDATE_NEED_ESECUTORE';
export const RESET_DATI_MOD_PAGAMENTO              = 'RESET_DATI_MOD_PAGAMENTO';